/**
 * NOTE: In most cases it is not necessary to add query strings to this file, since the directory is
 * an actual GraphQL API with introspection. Instead, declare the query strings you need locally in
 * your component file.
 */
import { GET_ACTIVE_ENTITIES, getActiveEntities } from './getActiveEntities';
import { GET_DETECTION_DATA, getDetectionData } from './getDetectionData';
import {
    GET_ENTITIES_WITH_UPLOADED_STATEMENTS,
    getEntitiesWithUploadedStatements,
} from './getEntitiesWithUploadedStatements';
import {
    GET_STATEMENT_PERFORMANCE_DATA,
    getStatementPerformanceData,
} from './getStatementPerformanceData';
import { GET_TRQK_SONG, GET_TRQK_SONG_FIELDS } from './getTrqkSong';
import { GET_TRQK_USER } from './getTrqkUser';
import { GET_TRACK_TABLE_ROWS_FOR_UNMATCHED } from './tracksQueries';

import { LIST_BMAT_DETECTIONS_ITEM_FIELDS } from './listBmatDetections';
import {
    updateDetectionStatuses,
    UPDATE_DETECTION_STATUSES,
} from './updateDetectionStatuses';
import { UPDATE_TRQK_SONG } from './updateTrqkSong';

export const trqkDirectoryQueryStrings = {
    GET_ACTIVE_ENTITIES,
    GET_DETECTION_DATA,
    GET_ENTITIES_WITH_UPLOADED_STATEMENTS,
    GET_STATEMENT_PERFORMANCE_DATA,
    GET_TRACK_TABLE_ROWS_FOR_UNMATCHED,
    GET_TRQK_SONG,
    GET_TRQK_USER,
    UPDATE_DETECTION_STATUSES,
    UPDATE_TRQK_SONG,
};

export const trqkDirectoryQueries = {
    getActiveEntities,
    getDetectionData,
    getEntitiesWithUploadedStatements,
    getStatementPerformanceData,
};

export const trqkDirectoryMutations = {
    updateDetectionStatuses,
};

export const trqkDirectoryFields = {
    GET_TRQK_SONG_FIELDS,
    LIST_BMAT_DETECTIONS_ITEM_FIELDS,
};
